module.exports = __webpack_public_path__ + "media/1_3-62.2bae6b0b.mp3";